import { Component } from 'react'
import * as o from 'rxjs/operators'
import PT from 'prop-types'
import R from 'ramda'
import mkInterface from 'orq/interface'

import { O as Observable } from '#utils/rx'
// eslint-disable-next-line import/default
import OrqWorker from '#utils/orq.worker.js'

const orq = mkInterface(new OrqWorker())

class RequestProvider extends Component {
  static propTypes = {
    children: PT.node,
  }

  static childContextTypes = {
    request: PT.func,
  }

  getChildContext() {
    return { request: this.request }
  }

  request = (...args) =>
    orq.addRequest(...args).pipe(
      o.catchError((err) => {
        if (R.pathEq(401, ['response', 'status'], err)) {
          window.addEventListener('unload', () => {
            window.localStorage.clear()
          })
          window.location.assign('/login')
          return Observable.empty()
        }

        return Observable.throw(err)
      })
    )

  render() {
    return this.props.children
  }
}

export default RequestProvider
